import React, { useEffect, useState } from "react";

import AsyncSelectInput from "../../../../../components/Inputs/AsyncSelectInput";
import SelectInput, { Result } from "../../../../../components/Inputs/SelectInput";

import useQueryBuilderStore from "../store";

interface BaseProps {
	onChange: (value: any) => void;
	value: string;
}

export const GoalPicker = (props: BaseProps) => {
	const [valueLabelGoalMaps] = useQueryBuilderStore((state) => [state.valueLabelMaps.goal]);
	const { onChange, value } = props;
	let displayValue;

	const [fetchGoals] = useQueryBuilderStore((state) => [state.fetchGoals]);

	// This is used since value is only the objectId, but we need a result object with the label
	// or a currently loaded goal (which may not occur due to the limit in this call)
	// therefore, we leverage the store's cacheing of goals to get the label.
	// The store should cache any searched goal, or any that currently exists in the filter builder.
	if (Object.keys(valueLabelGoalMaps).filter((key) => key === value).length > 0) {
		displayValue = { value, label: valueLabelGoalMaps[value] } as Result;
	}

	return (
		<AsyncSelectInput placeholder="Select..." fetchOptions={fetchGoals} onChange={onChange} value={displayValue} />
	);
};

interface GoalCategoryPickerBaseProps {
	onChange: (value: any) => void;
	value: unknown;
}

export const GoalCategoryPicker = (props: GoalCategoryPickerBaseProps) => {
	const { onChange, value } = props;
	const [fields, setFields] = useState<Result[]>([]);
	const [fetchGoalCategories] = useQueryBuilderStore((state) => [state.fetchGoalCategories]);

	const getCategories = async () => {
		const categories = await fetchGoalCategories();
		setFields(categories);
	};

	useEffect(() => {
		getCategories();
	}, []);

	return <SelectInput results={fields} onChange={onChange} value={value as Result} />;
};

export const GoalOutlookPicker = (props: BaseProps) => {
	const [fields, setFields] = useState<Result[]>([]);
	const { onChange, value } = props;

	const [fetchGoalOutlooks] = useQueryBuilderStore((state) => [state.fetchGoalOutlooks]);

	const getOutlooks = async () => {
		const outlooks = await fetchGoalOutlooks();
		setFields(outlooks);
	};

	useEffect(() => {
		getOutlooks();
	}, []);

	return (
		<SelectInput
			results={fields}
			onChange={onChange}
			value={value}
			formatOptionLabel={(value) => {
				return (
					<div className="flex items-center gap-x-1">
						<div style={{ backgroundColor: value.color }} className="h-3 w-3 shrink-0 rounded-full" />
						<div>{value.label}</div>
					</div>
				);
			}}
		/>
	);
};
